export default __webpack_public_path__ + "media/flowserve_photo.3e2d411a.jpg";